import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { closeImportFailedModal } from '../features/import/importSlice';
import { pushModal } from '../features/globalModals/globalModalsSlice';
import ImportFailedModal from './ImportFailedModal';

const GlobalImportFailedModal: React.FC = () => {
  const dispatch = useDispatch();
  const { failedModal } = useSelector((state: RootState) => state.import);

  const handleClose = () => {
    dispatch(closeImportFailedModal());
  };

  const handleTryAgain = () => {
    // Close the failed modal
    dispatch(closeImportFailedModal());

    // Open the import modal with the same URL
    dispatch(
      pushModal({
        type: 'import-urls-modal',
        url: failedModal.invalidUrl || '',
      })
    );
  };

  return failedModal.isOpen ? (
    <ImportFailedModal
      open
      onClose={handleClose}
      invalidUrl={failedModal.invalidUrl}
      onTryAgain={handleTryAgain}
    />
  ) : null;
};

export default GlobalImportFailedModal;
